import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const FormationPage = lazy(() => import('../pages/formation/page'));
const BookkeepingPage = lazy(() => import('../pages/bookkeeping/page'));
const TaxesPage = lazy(() => import('../pages/taxes/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const VIPClubPage = lazy(() => import('../pages/vip-club/page'));
const WallOfLovePage = lazy(() => import('../pages/wall-of-love/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const DemoPage = lazy(() => import('../pages/demo/page'));
const AICofounderPage = lazy(() => import('../pages/ai-cofounder/page'));
const ComparisonPage = lazy(() => import('../pages/comparison/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/formation',
    element: <FormationPage />,
  },
  {
    path: '/bookkeeping',
    element: <BookkeepingPage />,
  },
  {
    path: '/taxes',
    element: <TaxesPage />,
  },
  {
    path: '/analytics',
    element: <AnalyticsPage />,
  },
  {
    path: '/ai-cofounder',
    element: <AICofounderPage />,
  },
  {
    path: '/comparison',
    element: <ComparisonPage />,
  },
  {
    path: '/vip-club',
    element: <VIPClubPage />,
  },
  {
    path: '/wall-of-love',
    element: <WallOfLovePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/demo',
    element: <DemoPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
